/**
 * Маркер web-сессии в WebView.
 *
 * В WebView web-сторона авторизуется сама: обменивает суперапп-сессию нативы на
 * собственный JWT через `sso.authorize` (мост) → `POST /sso/authorize` (бэк).
 * Токен держит `clientApi` (`ssoJwtToken`) и подставляет в запросы; протух (401)
 * — повторяем обмен (см. client.api.ts). Авторизацию инициирует AuthProvider при
 * входе в модуль.
 *
 * Настоящая личность пользователя (ИИН) в web НЕ приходит — она живёт в нативе и
 * на бэке (через токен сессии). В redux `client.iin` кладём этот маркер:
 * значение нигде не отображается и не отправляется на бэк, используется только
 * как гейт авторизации (см. requests.tsx, ProtectedRoute).
 */
export const WEBVIEW_SESSION_MARKER = 'webview-session';
